import { render, staticRenderFns } from "./editProductModel.vue?vue&type=template&id=be90daa2&scoped=true"
import script from "./editProductModel.vue?vue&type=script&lang=js"
export * from "./editProductModel.vue?vue&type=script&lang=js"
import style0 from "./editProductModel.vue?vue&type=style&index=0&id=be90daa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be90daa2",
  null
  
)

export default component.exports